import { render } from "./important-date-term-navigation.vue?vue&type=template&id=1830d44b&scoped=true"
import script from "./important-date-term-navigation.vue?vue&type=script&lang=js"
export * from "./important-date-term-navigation.vue?vue&type=script&lang=js"

import "./important-date-term-navigation.vue?vue&type=style&index=0&id=1830d44b&scoped=true&lang=css"

import exportComponent from "/srv/clubs/releases/20240415150343/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1830d44b"]])

export default __exports__